import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {useState} from "react";
import {useTranslation} from "react-i18next";

export default function RestaurantEventsInfoButton() {
    const {t} = useTranslation();
    const [anchor, setAnchor] = useState<HTMLButtonElement | null>(null);

    return (
        <>
            <IconButton
                size="small"
                aria-label={t("Events info")}
                onClick={event => setAnchor(event.currentTarget)}
                sx={{color: "text.secondary", flexShrink: 0}}
            >
                <InfoOutlinedIcon fontSize="small"/>
            </IconButton>
            <Popover
                open={Boolean(anchor)}
                anchorEl={anchor}
                onClose={() => setAnchor(null)}
                anchorOrigin={{vertical: "bottom", horizontal: "left"}}
                transformOrigin={{vertical: "top", horizontal: "left"}}
                PaperProps={{sx: {maxWidth: 360, p: 2}}}
            >
                <Stack gap={1.25}>
                    <Box>
                        <Typography variant="subtitle2" sx={{fontWeight: 700}}>
                            {t("Prolonged stay")}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {t("Prolonged stay info")}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" sx={{fontWeight: 700}}>
                            {t("Early departure")}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {t("Early departure info")}
                        </Typography>
                    </Box>
                </Stack>
            </Popover>
        </>
    );
}
